//Third party libraries

import NumericMetricWidget from '@/components/Widgets/NumericMetricWidget';
import { kFormatterWithAbbreviation } from '@/utils';
//Services
import { useDashboardData } from '../../../hooks/ReactQueryHooks/useDashboardQuery';
import type { DashboardType } from '../../../types/Analytics';
//Assets and miscellaneous
import { Widget } from '../constants';
//Custom components
import WidgetLayout from '../WidgetLayout';

interface BudgetItem {
  name: string;
  amount: number;
}

interface DataItem {
  id: number;
  name: string;
  budget: BudgetItem[];
}

const DevelopmentPipelineWidget = ({ dashboard }: { dashboard: DashboardType }) => {
  const fetchProjectBudgetSummaryData = useDashboardData({
    dashboard,
    widget: Widget.PROJECT_BUDGET_SUMMARY,
  });

  const sumBudgetAmount = (data: DataItem[]): number =>
    data?.reduce((totalAmount, item) => {
      return (
        totalAmount +
        item.budget.reduce((itemTotal, budgetItem) => {
          return itemTotal + (budgetItem.amount ? budgetItem.amount : 0);
        }, 0)
      );
    }, 0);

  const totalUnitsInDevelopment = sumBudgetAmount(fetchProjectBudgetSummaryData?.data?.data);

  const formattedValue = kFormatterWithAbbreviation(String(totalUnitsInDevelopment));

  return (
    <WidgetLayout dashboard={dashboard} widget={Widget.PROJECT_BUDGET_SUMMARY} actionsBtnLocation='top-2 right-0'>
      <NumericMetricWidget
        title='Development Pipeline'
        value={formattedValue.value ? formattedValue.value : '0'}
        prefix='$'
        suffix={formattedValue.abbreviation ? formattedValue.abbreviation : ''}
      />
    </WidgetLayout>
  );
};

export default DevelopmentPipelineWidget;
